import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import AboutHeader from './about/AboutHeader';
import AboutValues from './about/AboutValues';
import AboutMissionVision from './about/AboutMissionVision';
import AboutPerspectives from './about/AboutPerspectives';
import AboutTeam from './about/AboutTeam';
import AboutClutch from './about/AboutClutch';
import Footer from './common/Footer';
import { companyInfoPropsType, getAboutContent } from '../helpers/fetchCmsContent';
import AboutTeamImage from './about/AboutTeamImage';
import Directus from '../helpers/directusLink';

const About = ({
    t, openPage, language, claim, companyInfo
}) => {
    const [content, setContent] = useState(null);

    useEffect(() => {
        const fetchContent = async () => {
            const data = await getAboutContent();
            setContent(data);
        };

        fetchContent();
    }, []);

    const values = useMemo(() => {
        if (!content) return [];
        const valueItems = content.values.map((el) => el.brand_value_id);
        return valueItems.map((el) => ({ icon: el.icon, ...Directus.getTranslationByLang(el.translations, language, ['name', 'description']) }));
    }, [content, language]);

    const contentTranslation = useMemo(() => {
        if (!content) return {};
        return Directus.getTranslationByLang(content.translations, language, ['about', 'vision', 'story', 'mission']);
    }, [content, language]);

    return (
        <div className="page-about">
            <AboutHeader t={ t } text={ contentTranslation.about || '' }/>
            <AboutTeam t={ t } story={ contentTranslation.story || '' }/>
            <AboutValues t={ t } values={ values }/>
            <AboutMissionVision t={ t } mission={ contentTranslation.mission || '' } vision={ contentTranslation.vision || '' }/>
            <AboutPerspectives t={ t } language={ language }/>
            <AboutTeamImage/>
            <AboutClutch t={ t }/>
            <Footer t={ t } openPage={ openPage } language={ language } claim={ claim } companyInfo={ companyInfo }/>
        </div>
    );
};
About.defaultProps = {
    companyInfo: null
};

About.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    claim: PropTypes.string.isRequired,
    companyInfo: companyInfoPropsType
};

export default About;



// WEBPACK FOOTER //
// ./src/components/content/About.jsx